import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { MfaEnrollPage } from '../../auth/mfa-enroll-page';

/**
 * `/mfa/enroll` (M2.7, SECURITY.md §4.3, FR-ADMIN-01).
 *
 * Reachable before enrolment is complete, which is why it is in `MFA_ENROLMENT_PATHS`
 * and renders outside the shell. An anonymous visitor here has nothing to enrol: the API
 * answers `401` on the first call and the client puts them back to `/login`.
 */
export const Route = createFileRoute('/mfa/enroll')({
  component: MfaEnrollRoute,
});

function MfaEnrollRoute() {
  const navigate = useNavigate();
  return (
    <MfaEnrollPage
      onDone={() => {
        void navigate({ to: '/', replace: true });
      }}
    />
  );
}
